import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'

export interface PatientsFilters {
	search?: string
	insurance_company?: number[]
}

export const QUERY_KEY = 'patients'

export const DEFAULT_FILTERS: PatientsFilters = {
	search: '',
	insurance_company: []
}

export const fetchFn = async (pagination: Pagination, filters: PatientsFilters = {}) => {
	const query = fetchQuery(pagination, filters)

	return wAxios.post_auth(`v1/patients-list`, query).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: PatientsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
		page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		insurance_company: filtersWithDefaults.insurance_company?.length ? filtersWithDefaults.insurance_company : ''
	}

	return query
}

export const useGetPatients = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
